const imagesPath = [
  {
    img1: "/company_pic/tesla/teslaCar.webp",
    img2: "/company_pic/tesla/teslaCar3.webp",
    img3: "/company_pic/tesla/teslaCar2.webp",
    banner: "/customBanners/teslaRed.webp",
    company: "Tesla",
    desc: "Autonomy meets luxury design in Tesla's groundbreaking RoboTaxi platform. This early access program showcases the future of sustainable urban transportation.",
    point1: "• Book instantly through the Tesla app and the vehicle comes to you - no parking hassles, no designated driver needed.",
    point2: "• Relax during your journey - catch up on work, take a nap, or enjoy entertainment while the vehicle handles traffic."
  },
  {
    img1: "/company_pic/disney/disney1.webp",
    img2: "/company_pic/disney/disney2.webp",
    img3: "/company_pic/disney/disney3.webp",
    banner: "/customBanners/disney-banner.webp",
    company: "Disney",
    desc: "Disney redefines entertainment with immersive storytelling and magical experiences for all ages, blending innovation with nostalgia.",
    point1: "• Explore a vast collection of movies, series, and exclusive content on Disney+.",
    point2: "• Experience the magic firsthand with theme parks, cruises, and live events worldwide."
  },
  {
    img1: "/company_pic/live/live1.webp",
    img2: "/company_pic/live/live2.webp",
    img3: "/company_pic/live/live3.webp",
    banner: "/customBanners/live-nation banner.webp",
    company: "Live Nation",
    desc: "Live Nation brings fans closer to their favorite artists through unforgettable concerts, festivals, and live experiences worldwide.",
    point1: "• Book tickets to the hottest concerts, festivals, and events in one place.",
    point2: "• Enjoy exclusive VIP access, meet-and-greets, and premium fan experiences."
  },
  {
    img1: "/company_pic/delta/delta1.webp",
    img2: "/company_pic/delta/delta2.webp",
    img3: "/company_pic/delta/delta3.webp",
    banner: "/customBanners/delta-new-banner.webp",
    company: "Delta",
    desc: "Delta Airlines offers world-class travel experiences with comfort, reliability, and customer-first service.",
    point1: "• Enjoy seamless global travel with award-winning customer service and premium lounges.",
    point2: "• Earn miles and exclusive perks with Delta SkyMiles loyalty program."
  },
  {
    img1: "/company_pic/starbucks/starbuck1.webp",
    img2: "/company_pic/starbucks/starbuck2.webp",
    img3: "/company_pic/starbucks/starbuck3.webp",
    banner: "/customBanners/starbucks-banner-new.webp",
    company: "Starbucks",
    desc: "Starbucks delivers handcrafted beverages and premium coffee experiences with sustainability at its core.",
    point1: "• Enjoy expertly crafted coffee, tea, and seasonal drinks at thousands of locations.",
    point2: "• Earn rewards and customize orders via the Starbucks app."
  },
  {
    img1: "/company_pic/nike/nike1.webp",
    img2: "/company_pic/nike/nike2.webp",
    img3: "/company_pic/nike/nike3.webp",
    banner: "/customBanners/black-nike-banner.webp",
    company: "Nike",
    desc: "Nike leads the way in athletic innovation, inspiring athletes and sports enthusiasts with top-tier footwear and apparel.",
    point1: "• Shop performance-driven sneakers, apparel, and gear for all sports.",
    point2: "• Personalize and customize your own Nike shoes with exclusive designs."
  },
  {
    img1: "/company_pic/chipotle/chipotle3.webp",
    img2: "/company_pic/chipotle/chipotle2.webp",
    img3: "/company_pic/chipotle/chipotle1.webp",
    banner: "/customBanners/Chip-new-banner.webp",
    company: "Chipotle",
    desc: "Chipotle redefines fast-casual dining with responsibly sourced ingredients and customizable Mexican-inspired meals.",
    point1: "• Enjoy fresh, high-quality ingredients with no artificial flavors, colors, or preservatives.",
    point2: "• Customize your burrito, bowl, or tacos with organic and locally sourced produce."
  },
  {
    img1: "/company_pic/airbnb/airbnb1.webp",
    img2: "/company_pic/airbnb/airbnb2.webp",
    img3: "/company_pic/airbnb/airbnb3.webp",
    banner: "/customBanners/airbnb-new-banner.webp",
    company: "Airbnb",
    desc: "Airbnb revolutionizes travel by connecting guests with unique stays, from cozy homes to luxury villas worldwide.",
    point1: "• Discover stays tailored to your needs, whether for work, vacation, or long-term stays.",
    point2: "• Experience local culture with personalized hospitality and exclusive Airbnb experiences."
  },
  {
    img1: "/company_pic/chase/chase1.webp",
    img2: "/company_pic/chase/chase2.webp",
    img3: "/company_pic/chase/chase3.webp",
    banner: "/customBanners/chase-banner-new.webp",
    company: "Chase",
    desc: "Chase provides world-class banking solutions, from credit cards to investment services, designed to empower your financial future.",
    point1: "• Manage your finances with ease through Chase's secure and user-friendly digital banking services.",
    point2: "• Enjoy rewards, cashback, and exclusive perks with Chase credit cards tailored to your lifestyle."
  }
];

export default imagesPath;

